<template>
  <div class="card">
    <div class="card-header">
      <i class="fa fa-info-circle mr-05"></i> Historique
    </div>
    <div class="card-block">
      <Log :order="order" />
    </div>
  </div>
</template>

<script>
import Log from "@/components/utils/Log";

export default {
  components: {
    Log,
  },

  props: {
    order: {
      type: Object,
      required: true,
    },
  },
};
</script>
